import { FunctionComponent } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import styles from './styles.module.scss';

type PayPalProps = {
    paypalOrderId: string | undefined;
    onPaymentSuccess: () => void;
};

export const PayPal: FunctionComponent<PayPalProps> = ({ paypalOrderId, onPaymentSuccess }) => {
    if (!paypalOrderId) {
        console.error('No Paypal order id provided');
        return null;
    }

    return (
        <div className={styles.container}>
            <PayPalScriptProvider
                options={{
                    clientId: process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID || '',
                    currency: 'GBP',
                }}
            >
                <PayPalButtons
                    style={{ layout: 'vertical' }}
                    createOrder={async (data, actions) => {
                        return paypalOrderId;
                    }}
                    onApprove={async (data, actions) => {
                        onPaymentSuccess();
                    }}
                    onInit={(data, actions) => {
                        console.log('Paypal buttons initialised', data, actions);
                    }}
                />
            </PayPalScriptProvider>
        </div>
    );
};
